export const noopValidator = () => ({});
//# sourceMappingURL=noop.validator.js.map